import { HttpClient } from "@angular/common/http";
import { isDevMode } from "@angular/core";
import { Injectable } from "@angular/core";

import { CookieService } from 'ngx-cookie-service';

import {  timer, Subject, Observable } from "rxjs";
import { catchError } from 'rxjs/operators';

import { EnvService } from "../env.service";
import { UserProfile } from "../shared/models/userProfile";
import { RivirHttp } from "../shared/services/rivir-http.service";
import { WorkflowService } from "../shared/services/workflow.service";
import {
  RivirAPI,
  RivirAPIFilter,
  RivirObject,
} from "../rivirapi/rivirapi.sdk";
import { KeycloakService } from "./keycloak/keycloak.service";

@Injectable()
export class UserProfileService {

  public subscription;
  public profile: any = null;
  public fullName = "";
  public accountType = "";
  public userEmail = "";
  public profilePic = "../images/user.png";
  private userProfile = new Subject<any>();
  private usersListing: string[] = [];
  private usersNameMap: NameMapObject[] = [];
  private timerStarted = false;

  private _userProfileUrl: string;
  private _rivirKeycloakUrl: string; 

  constructor(
    private _http: HttpClient,
    private kc: KeycloakService,
    private workflowService: WorkflowService,
    private rivirApi: RivirAPI,
    private cookieService: CookieService,
    private env: EnvService
  ) {
    this._userProfileUrl = this.env.rivirApiBaseUrl + "/userprofiles";
    this. _rivirKeycloakUrl = this.env.rivirApiBaseUrl + "/keycloak";
    this.fullName = `${this.cookieService.get("firstName")} ${this.cookieService.get("lastName")}`;
    this.accountType = this.cookieService.get("role");
    this.userEmail = this.cookieService.get("email");
    this.profilePic = this.cookieService.get("profilePic")
      ? this.cookieService.get("profilePic")
      : "images/user.png";

    // TODO remove this and data from the cookie
    const profileHeaders = {
      fullName: this.fullName,
      accountType: this.accountType,
      profilePic: this.profilePic,
      email: this.userEmail,
    };
    this.setUserProfile(profileHeaders);

    // TODO This should be moved the the startup service and the 5 minute time interval should
    // be in configuration
    // TODO Part 2 - This should really be handled by the cookie an not constantly pinging the server
    this.addIntervalTimertoCheckUserAccess(5);
  }

  public handleException(error: Response) {
    console.error(error);
    return Observable.throw(error.statusText || "Server Error");
  }

  public resetPassword(keycloakId: string): Observable<any> {
    const url = `${this._rivirKeycloakUrl}/resetPassword/${keycloakId}/${this.userEmail
      }`;
    return this._http.post(url, null, RivirHttp.getHttpOptions());
  }

  public async saveUserProfile(userProfile: UserProfile) : Promise<any>{
    const url = `${this._userProfileUrl}/updateOne`;
    const response = await this._http.post(url, userProfile , RivirHttp.getHttpOptions()).toPromise();
    return response;      
  }

  public loadUserProfile() {
    new Promise<void>((resolve) => {

      this.kc
        .loadUserProfile()
        .then()
        .then((profile) => {
          this.profile = profile;

          if (this.profile != null) {
            // we should check to see if the user profile exists from the sso agent
            // if it doesn't we should register this account
            // check the api to see if the email exists
            const filter: RivirAPIFilter = new RivirAPIFilter(null);
            filter.setFilterType("where");
            filter.addExpression({ email: this.profile.username });
            // if now continue and let angular routing work
            this.rivirApi
              .getRequestWithPath("userprofiles", filter)
              .pipe(catchError(RivirHttp.handleError))
              .subscribe((rivirResponse) => {
                const userProfiles = rivirResponse.getData();

                if (userProfiles != null && userProfiles.length == 1) {
                  // set attach the rivir profile to the keycloak profile
                  this.profile.rivirUserProfile = userProfiles[0].getJSONObject();

                  this.fullName = `${this.profile.rivirUserProfile.firstName} ${this.profile.rivirUserProfile.lastName
                    }`;
                  this.accountType = this.profile.rivirUserProfile.accountType;
                  this.userEmail = this.profile.rivirUserProfile.email;
                  this.profilePic = this.profile.rivirUserProfile.profilePicUrl
                    ? this.profile.rivirUserProfile.profilePicUrl
                    : "images/user.png";

                  // set the Cookie for the name and email address and role
                  // TODO the whole userprofile and keycloak object should be saved to the cookie instead of some properties
                  this.cookieService.set("email", this.profile.rivirUserProfile.email);
                  this.cookieService.set("name", this.profile.rivirUserProfile.name);
                  this.cookieService.set("firstName", this.profile.firstName);
                  this.cookieService.set("lastName", this.profile.lastName);
                  this.cookieService.set("role", this.profile.rivirUserProfile.accountType);
                  this.cookieService.set("userProfileId", this.profile.rivirUserProfile.id);


                  const getToken = this.kc.getToken();

                  getToken.then((token) => {
                    this.profile.password = token; // Not used

                    this.cookieService.set("userProfile", this.profile);

                    this.workflowService.loginUser(
                      this.profile.username,
                      this.profile.firstName,
                      this.profile.lastName,
                      this.profile.email,
                      token,
                      this.profile.accountType,
                    );
                  });
                } else {
                  const getToken = this.kc.getToken();

                  getToken.then((token) => {
                    this.profile.password = token;

                    this.cookieService.set("userProfile", this.profile);

                    // create a new user profile, defaulted with values
                    this.registerUser(
                      this.profile.id,
                      this.profile.password,
                      this.profile.username,
                      this.profile.firstName,
                      this.profile.lastName,
                    );
                  });
                }
                const profileHeaders = {
                  fullName: this.fullName,
                  accountType: this.accountType,
                  profilePic: this.profilePic,
                  email: this.userEmail
                };
                this.setUserProfile(profileHeaders);

                if (!this.timerStarted) {
                  this.addIntervalTimertoCheckUserAccess(5);
                  this.timerStarted = true;
                }

                resolve();
              });
          }
        })
        .catch((e) => resolve());
    });
  }

  public setUserProfile(state: any) {
    if (
      this.usersNameMap &&
      this.usersNameMap.length &&
      this.usersNameMap.find((x) => x.email == this.userEmail)
    ) {
      const i = this.usersNameMap.indexOf(
        this.usersNameMap.find((x) => x.email == this.userEmail),
      );
      this.usersNameMap.splice(i, 1); // Reset UserFullNameMap stored for the current user
    }
    this.userProfile.next(state);
  }

  public getUserProfile(): Observable<any> {
    return this.userProfile.asObservable();
  }

  public getUsersProfile(id: string): Observable<UserProfile> {
    const url: string = this._userProfileUrl + "/" + id;
    return this._http
      .get<UserProfile>(url, RivirHttp.getHttpOptions())
      .pipe(catchError(RivirHttp.handleError));
  }

  public resetUsersPasswordDates(
    username: string,
    updatedBy: string,
  ): Observable<any> {
    const initialDate = username ? new Date().toISOString() : "";
    username = username || "";
    const url = `${this._userProfileUrl}/resetPasswordDates`;
    const data = { initialDate, username, updatedBy };
    return this._http
      .post(url, data, RivirHttp.getHttpOptions())
      .pipe(catchError(RivirHttp.handleError));
  }

  /**
   * Gets all active User Profile
   */
  public getActiveUsers(): Observable<UserProfile[]> {
    const url: string =
      this._userProfileUrl + '?filter={ "where" : {"active" : true} }';
    return this._http
      .get<UserProfile[]>(url, RivirHttp.getHttpOptions())
      .pipe(catchError(RivirHttp.handleError));
  }

  /**
   * Gets all non system users
   */
  public getNonSystemUsers(): Observable<UserProfile[]> {
    const url: string =
      this._userProfileUrl + '/nonsystem?filter={ "where" : {"active" : true} }';
    return this._http
      .get<UserProfile[]>(url, RivirHttp.getHttpOptions())
      .pipe(catchError(RivirHttp.handleError));
  }

  public getProfilecompletePercent(profile): number {
    const fields = [
      "email",
      "username",
      "firstName",
      "lastName",
      "profilePicUrl",
      "accountType",
      "officeLocation",
      "organization",
      "cellPhoneNumber",
      "homePhoneNumber",
    ];
    let percent = 0;
    for (let i = 0; i < fields.length; i++) {
      if (
        profile &&
        profile[fields[i]] &&
        profile[fields[i]].indexOf("/user.png") == -1
      ) {
        percent = percent + 10;
      }
    }
    return percent;
  }

  public getUserProfileByEmail(filterValue: string): Observable<any> {
    const filter = `?filter={"where" : {"email" : "${filterValue}"}}`;
    const url: string = this._userProfileUrl + filter;
    return this._http
      .get<any>(url, RivirHttp.getHttpOptions())
      .pipe(catchError(RivirHttp.handleError));
  }

  public getGroups(groupName: string): Observable<any> {
    let url = `${this._userProfileUrl}/groups`;
    if (groupName) {
      url += `?groupName=${groupName}`;
    }
    return this._http
      .get<any>(url, RivirHttp.getHttpOptions())
      .pipe(catchError(RivirHttp.handleError));
  }

  public saveUsers(users: UserProfile[], updatedBy): Observable<any> {
    const url = `${this._userProfileUrl}/saveUsers`;
    return this._http
      .post(url, { users, updatedBy }, RivirHttp.getHttpOptions())
      .pipe(catchError(RivirHttp.handleError));
  }

  public getSuccessfulLogin(username: string): Observable<any> {
    const userLoginUrl = `${this.env.rivirApiBaseUrl}/securityAudit/userLogin?username=${username}`;

    return this._http
      .get(userLoginUrl, RivirHttp.getHttpOptions())
      .pipe(catchError(RivirHttp.handleError));
  }

  public addIntervalTimertoCheckUserAccess(minutes) {
    const milliseconds = minutes * 60 * 1000;
    const _timer = timer(1000, milliseconds);
    this.subscription = _timer.subscribe((ct) => {
      this.getUserProfileByEmail(this.userEmail).subscribe((res) => {
        if (res[0] && res[0].active == false) {
          this.kc.logout( "addIntervalTimertoCheckUserAccess" );
          this.subscription.unsubscribe();
        }
      });
    });
  }

  public registerUser(
    ssoId: string,
    token: string,
    email: string,
    firstname: string,
    lastname: string,
  ): void {
    const data = new UserProfile();
    data.active = false;
    data.email = email;
    data.name = firstname + " " + lastname;
    data.firstName = firstname;
    data.lastName = lastname;
    data.username = email;
    data.profilePicUrl = "./images/user.png";
    data.manager = "";
    data.ssoId = ssoId;
    data.token = token;
    data.accountType = "Reporter";
    data.CreatedBy = email;
    data.UpdatedBy = email;
    data.CreatedDateTime = new Date();
    data.UpdatedDateTime = new Date();

    // Default the date to 90 days from this date
    // TODO set the date to 90 days from now
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 90);
    data.passwordExpirationDate = currentDate;

    const parameters: RivirObject = new RivirObject(null);
    parameters.setData(data);

    this.rivirApi
      .postRequestWithPath("userprofiles", parameters)
      .pipe(catchError(RivirHttp.handleError))
      .subscribe((rivirResponse) => {
        if (rivirResponse.getStatusCode() == 200) {
          
          // save the email and id to the filesystem
          const userProfile = rivirResponse.getData();

          if (userProfile != null) {
            this.cookieService.set("email", userProfile.email);
            this.cookieService.set("user-id", userProfile.id);
          }
        } else {
          if (isDevMode()) {
            console.error(
              "An error occurred while creating new account. Status Code: " +
              rivirResponse.getStatusCode() +
              ", Error: " +
              rivirResponse.getMessage(),
            );
          }
        }
      });
  }

  public getUserFullNameFromEmail(userEmail) {
    return new Promise<NameMapObject>((resolve, reject) => {
      if (!userEmail) {
        resolve(null);
      } else if (userEmail == "System") {
        resolve({ email: userEmail, fullName: userEmail });
      } else {
        this.getUserProfileByEmail(userEmail).subscribe((res) => {
          const user = res[0] || res || null;
          const userFullName =
            user.name ||
            (user.firstName ? user.firstName + " " + user.lastName : null);
          const obj = {
            email: userEmail,
            fullName: userFullName ? userFullName : userEmail,
          };
          resolve(obj);
        });
      }
    });
  }

  public addUserEmailToUsersListing(userEmail) {
    if (this.usersListing.indexOf(userEmail) == -1) {
      this.usersListing.push(userEmail);
    }
  }

  public getusersNameMap() {
    return new Promise<any[]>((resolve, reject) => {
      const promises = [];
      this.usersListing.forEach((userEmail) => {
        const found = this.usersNameMap.find((x) => x.email == userEmail);
        if (!found) {
          promises.push(this.getUserFullNameFromEmail(userEmail));
        }
      });
      Promise.all(promises).then((res) => {
        for (let i = 0; i < res.length; i++) {
          this.usersNameMap.push(res[i]);
        }
        resolve(this.usersNameMap);
      });
    });
  }

  public getManagerStaffUsersCount() {
    const url = `${this._userProfileUrl}/count?where={"and" :[
      {"customManagerEmailAddress": "${this.userEmail}"},
      {"or" :[{"status": "Active"},{"status": "Inactive"},{"status": "Expired"}]}]}`;
    return this._http
      .get<any>(url, RivirHttp.getHttpOptions())
      .pipe(catchError(RivirHttp.handleError));
  }

  public getManagerStaffUsers() {
    const url = `${this._userProfileUrl}?filter={"where": {"and" :[
    {"customManagerEmailAddress": "${this.userEmail}"},
    {"or" :[{"status": "Active"},{"status": "Inactive"},{"status": "Expired"}]}]}}`;
    return this._http
      .get<any>(url, RivirHttp.getHttpOptions())
      .pipe(catchError(RivirHttp.handleError));
  }

}

export function getDefaultProfilePicBase64() {
  // default base64 user profile image
  return "data:image/png;base64,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";
}

export class NameMapObject {
  public email: string;
  public fullName: string;
}
